import './App.scss';
import Home from './pages/Home';
import {Routes, Route} from 'react-router-dom';
import About from './pages/About';
import Services from './pages/Services';
import BlogsPage from './pages/BlogsPage';
import BlogsFAQ from './pages/BlogsFAQ';
import SingleBlog from './pages/SingleBlog/SingleBlog';
import Contactus from './pages/Contact/Contactus';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton/ScrollToTopButton';

function App() {
  return (
    <>
      <ScrollToTop />
      <ScrollToTopButton />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/singleservice" element={<Services />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blogs-faq" element={<BlogsFAQ />} />
        <Route path="/blog/:url" element={<SingleBlog />} />
        <Route path="/contact" element={<Contactus />} />
      </Routes>
    </>
  );
}

export default App;
